import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { FallbackProps } from 'react-error-boundary'
import { Colors } from '~/assets/style/colors'
import { IllustrationMessage } from '~/components/IllustrationMessage'
import { Link } from '~/components/Link'
import { WithClassName } from '~/types/utils'
import { SUPPORT_MAIL } from '~/utils/constants'

const Wrapper = styled.div`
  background-color: ${Colors.Ghost};
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
`

type GlobalErrorPageProps = WithClassName & FallbackProps
const BaseGlobalErrorPage: FunctionComponent<GlobalErrorPageProps> = ({ className }) => {
  const refresh = () => window.location.reload()
  const clear = () => {
    window.localStorage.clear()
    refresh()
  }
  return (
    <Wrapper>
      <IllustrationMessage
        className={className}
        iconName={'night_sky'}
        iconSize={'190px'}
        title={'Oh no, the app is not feeling good'}
        message={
          <>
            <div>An error occurred, and we couldn't automatically recover from it.</div>
            <div>
              You can try to <Link onClick={refresh} label={'refresh'} trackingLabel={'common-global-error-refresh'} /> the page or{' '}
              <Link onClick={clear} label={'clear the cache'} trackingLabel={'common-global-error-clear-cache-apply'} />.
            </div>
            <div>
              If the problem persist, contact Pubstack's support: <Link target={'_blank'} href={`mailto:${SUPPORT_MAIL}`} label={SUPPORT_MAIL} trackingLabel={'common-mail-to-support-navigate'} />
            </div>
          </>
        }
      />
    </Wrapper>
  )
}
export const GlobalErrorPage = styled(BaseGlobalErrorPage)``
